import { Controller } from 'stimulus'

// Switches tab when the matches are only in the other one; clearing brings back the user's tab.
export default class extends Controller {
  static targets = [ 'input', 'clear', 'module', 'section', 'tab', 'pane', 'count', 'empty', 'recap', 'opened' ]

  connect() {
    this.chosenPane = this.activePane
  }

  showTab(event) {
    this.chosenPane = event.currentTarget.dataset.pane
    this.reveal(this.chosenPane)
  }

  filter() {
    const query = this.normalize(this.inputTarget.value.trim())

    this.clearTarget.hidden = query === ''

    this.moduleTargets.forEach(moduleElement => {
      const label = this.normalize(moduleElement.dataset.label)
      moduleElement.hidden = query !== '' && !label.includes(query)
    })

    this.sectionTargets.forEach(section => {
      section.hidden = this.modulesOf(section).every(module => module.hidden)
    })

    this.countTargets.forEach(count => {
      const matches = this.matchesIn(count.dataset.pane)
      count.textContent = matches
      count.hidden      = query === ''
    })

    this.emptyTargets.forEach(message => {
      const pane = message.closest('[data-pane]')
      message.hidden = query === '' || this.matchesIn(pane.dataset.pane) > 0
    })

    if (query === '') return this.reveal(this.chosenPane)

    // From the tab the user picked, never from wherever the previous search left them.
    const withMatches = this.panes.find(pane => this.matchesIn(pane) > 0)
    this.reveal(this.matchesIn(this.chosenPane) > 0 ? this.chosenPane : (withMatches || this.chosenPane))
  }

  recount() {
    if (!this.hasRecapTarget) return

    const pane = this.recapTarget.dataset.pane
    this.openedTarget.textContent = this.moduleTargets.filter(module =>
      module.dataset.pane === pane && module.querySelector('input[type="checkbox"]')?.checked
    ).length
  }

  clear() {
    this.inputTarget.value = ''
    this.inputTarget.focus()
    this.filter()
  }

  reveal(pane) {
    this.paneTargets.forEach(element => { element.hidden = element.dataset.pane !== pane })
    this.tabTargets.forEach(tab => tab.classList.toggle('is-active', tab.dataset.pane === pane))
  }

  matchesIn(pane) {
    return this.moduleTargets.filter(module => module.dataset.pane === pane && !module.hidden).length
  }

  modulesOf(section) {
    return this.moduleTargets.filter(module => section.contains(module))
  }

  get panes() {
    return this.paneTargets.map(pane => pane.dataset.pane)
  }

  get activePane() {
    return (this.paneTargets.find(pane => !pane.hidden) || this.paneTargets[0]).dataset.pane
  }

  normalize(text) {
    return text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  }
}
